/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable consistent-return */
import React, { FC, useEffect, useRef, useState } from 'react';
import { useProjectInfo } from 'domains/project/hooks';
import cn from 'classnames';
import css from './styles.module.scss';
import santaImg from './sprites/santa.svg';
import santaGreenImg from './sprites/santa_green.svg';

export const NewYearParallax: FC = () => {
  const { data: project, LTU: projectLTU } = useProjectInfo();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const snowCanvasRef = useRef<HTMLCanvasElement | null>(null);
  const [variant, setVariant] = useState<'BLUE' | 'GREEN' | null>(null);
  const BLUE_VARIANT = ['my.turbotarget.ru'];

  useEffect(() => {
    if (project && project.ext_domain) {
      if (BLUE_VARIANT.includes(project.ext_domain)) {
        setVariant('BLUE');
      } else {
        setVariant('GREEN');
      }
    }
  }, [project, projectLTU]);

  // ---------- ПАРАЛЛАКС ----------
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const mouse = { x: 0, y: 0 };

    const handleMove = (e: MouseEvent) => {
      const rect = container.getBoundingClientRect();
      mouse.x = e.clientX - (rect.left + rect.width / 2);
      mouse.y = e.clientY - (rect.top + rect.height / 2);

      applyParallax('layerBack', 90);
      applyParallax('layerMid', 50);
      applyParallax('layerTrees', 70);
      applyParallax('layerTreesFront', 45);
      applyParallax('layerFront', 25);
    };

    const applyParallax = (id: string, depth: number) => {
      const target = document.getElementById(id);
      if (!target) return;
      target.style.transform = `translate3d(${mouse.x / depth}px, ${
        mouse.y / depth
      }px, 0)`;
    };

    document.addEventListener('mousemove', handleMove);
    return () => document.removeEventListener('mousemove', handleMove);
  }, [variant]);

  // ---------- СНЕГ ----------
  useEffect(() => {
    const canvas = snowCanvasRef.current;
    const container = containerRef.current;
    if (!canvas || !container) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const w = (canvas.width = container.offsetWidth);
    const h = (canvas.height = container.offsetHeight);

    interface Flake {
      x: number;
      y: number;
      r: number;
      s: number;
    }

    const flakes: Flake[] = Array.from({ length: 120 }).map(() => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: Math.random() * 3 + 1,
      s: Math.random() * 1 + 0.3,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.beginPath();

      flakes.forEach((f) => {
        ctx.moveTo(f.x, f.y);
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);

        f.y += f.s;
        if (f.y > h) {
          f.y = -5;
          f.x = Math.random() * w;
        }
      });

      ctx.fill();
      requestAnimationFrame(draw);
    };

    draw();
  }, [variant]);

  // ---------- САНТА ----------
  useEffect(() => {
    const santa = document.getElementById('santa');
    if (!santa) return;

    const screenW = window.innerWidth;
    const screenH = window.innerHeight;

    const startX = screenW + 200;
    const endX = -200;
    const midY = screenH * 0.5; // центр экрана

    let progress = 0; // от 0 до 1

    const fly = () => {
      progress += 0.0015; // скорость

      if (progress >= 1) progress = 0; // рестарт плавный

      // Линейное движение X
      const x = startX + (endX - startX) * progress;

      // Парабола (дуга)
      // Чем выше "0.25", тем дуга круче
      const arcHeight = 200;
      const y = midY - Math.sin(progress * Math.PI) * arcHeight;

      santa.style.transform = `translate(${x}px, ${y}px)`;

      requestAnimationFrame(fly);
    };

    fly();
  }, [variant]);

  return (
    <div
      className={cn(css.container, {
        _isGreen: variant === 'GREEN',
      })}
      ref={containerRef}
    >
      <canvas ref={snowCanvasRef} className={css.snowCanvas} />
      {variant && (
        <>
          <div id="layerBack" className={`${css.layer} ${css.layerBack}`} />
          <div id="layerMid" className={`${css.layer} ${css.layerMid}`} />
          <div id="layerTrees" className={`${css.layer} ${css.layerTees}`} />
          <div
            id="layerTreesFront"
            className={`${css.layer} ${css.layerTeesFront}`}
          />
          <img
            src={variant === 'GREEN' ? santaGreenImg : santaImg}
            id="santa"
            className={css.santa}
            alt="Santa"
          />
        </>
      )}
    </div>
  );
};

export default NewYearParallax;
